module.exports = __webpack_public_path__ + "static/clock.5419e990.svg";